import React, { useEffect, useState } from 'react';
import { Eye, Ban, CheckCircle } from 'lucide-react';
import PartnerDetailsModal from './PartnerDetailsModal'; // মডাল ইম্পোর্ট নিশ্চিত করুন

const AdminPartners = ({ token }) => {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedPartner, setSelectedPartner] = useState(null); // মডাল স্টেট

    const loadData = () => {
        setLoading(true);
        fetch(`${import.meta.env.VITE_API_URL}/admin/referrers`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(res => res.json())
        .then(data => {
            setPartners(data);
            setLoading(false);
        })
        .catch(err => {
            console.error(err);
            setLoading(false);
        });
    };

    useEffect(() => { loadData(); }, []);

    const toggleStatus = async (id, currentStatus) => {
        const newStatus = currentStatus === 'active' ? 'banned' : 'active';
        if(!confirm(`Change status to ${newStatus.toUpperCase()}?`)) return;

        await fetch(`${import.meta.env.VITE_API_URL}/admin/referrers/${id}/status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ status: newStatus })
        });
        loadData();
    };

    return (
        <div className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden shadow-lg">
            <div className="p-6 border-b border-gray-700 flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">🤝 Partner Management</h3>
                <span className="bg-blue-900 text-blue-300 px-3 py-1 rounded-full text-xs font-bold">
                    Total: {partners.length}
                </span>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-left text-sm text-gray-300">
                    <thead className="bg-gray-900/50 uppercase text-xs font-bold text-gray-500">
                        <tr>
                            <th className="p-4">Partner Info</th>
                            <th className="p-4">Referrals</th>
                            <th className="p-4">Earnings</th>
                            <th className="p-4">Wallet</th>
                            <th className="p-4">Status</th>
                            {/* Actions এবং View Details কে একটি হেডারেই রাখা হলো */}
                            <th className="p-4 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                        {partners.map(p => (
                            <tr key={p.referrer_id} className="hover:bg-gray-700/30 transition">
                                <td className="p-4">
                                    <div className="font-bold text-white">{p.full_name}</div>
                                    <div className="text-xs text-gray-500">{p.email}</div>
                                    <div className="text-xs text-blue-400 font-mono mt-1">Code: {p.ref_code}</div>
                                </td>
                                <td className="p-4">
                                    <span className="text-lg font-bold text-white">{p.total_referrals}</span>
                                    <span className="text-xs text-gray-500 block">Doctors</span>
                                </td>
                                <td className="p-4 text-green-400 font-bold">
                                    ৳{p.total_earned}
                                </td>
                                <td className="p-4">
                                    <div className="font-bold text-white">৳{p.wallet_balance}</div>
                                    {p.pending_withdrawals > 0 && (
                                        <span className="text-xs text-yellow-400 animate-pulse">
                                            ● Pending Request
                                        </span>
                                    )}
                                </td>
                                <td className="p-4">
                                    <span className={`px-2 py-1 rounded text-xs font-bold uppercase ${
                                        p.status === 'active' ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'
                                    }`}>
                                        {p.status}
                                    </span>
                                </td>
                                
                                {/* Actions Column: Merged both buttons here */}
                                <td className="p-4 text-right">
                                    <div className="flex justify-end gap-3">
                                        {/* 1. View Details Button */}
                                        <button 
                                            onClick={() => setSelectedPartner(p.referrer_id)} 
                                            className="p-2 bg-gray-700 hover:bg-blue-600 text-blue-400 hover:text-white rounded transition" 
                                            title="View Activity Log"
                                        >
                                            <Eye size={18} />
                                        </button>

                                        {/* 2. Status Toggle Button */}
                                        <button 
                                            onClick={() => toggleStatus(p.referrer_id, p.status)}
                                            className={`p-2 rounded hover:bg-gray-700 transition ${p.status === 'active' ? 'text-red-400 hover:text-red-300' : 'text-green-400 hover:text-green-300'}`}
                                            title={p.status === 'active' ? 'Ban Partner' : 'Activate Partner'}
                                        >
                                            {p.status === 'active' ? <Ban size={18} /> : <CheckCircle size={18} />}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {partners.length === 0 && !loading && (
                            // colSpan 6 দিতে হবে কারণ আমরা কলাম কমিয়ে ৬টি করেছি
                            <tr><td colSpan="6" className="p-8 text-center text-gray-500">No partners found.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal Component */}
            <PartnerDetailsModal 
                isOpen={!!selectedPartner} 
                onClose={() => setSelectedPartner(null)} 
                partnerId={selectedPartner}
            />
        </div>
    );
};

export default AdminPartners;